import React from 'react';

import { SidebarGroup, SidebarMenu } from '@/components/ui/sidebar';
import { NAV_LINKS } from '../../../constants';
import LinkWithChildren from './LinkWithChildren';
import LinkWithoutChildren from './LinkWithoutChildren';

const NavLinks = () => (
  <SidebarGroup className="px-1 py-2">
    <SidebarMenu className="gap-0.5">
      {NAV_LINKS.map((link) =>
        link.nestedLinks ? (
          <LinkWithChildren key={link.label} link={link} />
        ) : (
          <LinkWithoutChildren key={link.label} link={link} />
        )
      )}
    </SidebarMenu>
  </SidebarGroup>
);

export default NavLinks;
